module.exports = __webpack_public_path__ + "img/icon-profile-info.5e60d6ab.svg";